import { render, staticRenderFns } from "./cms-link.vue?vue&type=template&id=6ac33826&scoped=true"
import script from "./cms-link.vue?vue&type=script&lang=js"
export * from "./cms-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac33826",
  null
  
)

export default component.exports